import {Component, ChangeDetectionStrategy} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ForgotPasswordRequest} from "@app/_models/api";
import {Router} from "@angular/router";
import {AuthService} from "@app/_services/auth.service";
import {ToastService} from "@app/_services/toast.service";

@Component({
    selector: 'app-forgot-password',
    imports: [
        NgOptimizedImage,
        ReactiveFormsModule
    ],
    templateUrl: './forgot-password.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
    formGroup = new FormGroup({email: new FormControl("", [Validators.required, Validators.email])});
    loading: boolean = false;

    constructor(private router: Router, private authService: AuthService, private toastService: ToastService) {
    }

    onSubmit() {
        if (this.formGroup.valid) {
            this.loading = true;
            const controls = this.formGroup.controls;

            const request: ForgotPasswordRequest = {email: controls.email.value!};
            this.authService.forgotPassword(request).subscribe({
                next: () => this.toastService.showInfo("Email sent", "Email sent to user with instructions to complete request."),
                error: () => {
                    this.loading = false;
                    this.toastService.showDanger("Request failed", "Please try again.");
                },
                complete: () => {
                    this.loading = false;
                    this.router.navigate(['account', 'reset-password']).then();
                },
            });
        }
    }
}
